<template>
  <div class="col-8 content-left">
    <div class="row">
      <transition name="fade">
        <div
          v-if="alertMessage"
          id="article-alert-message"
          :class="{ 'bg-danger': isErrorMessage }"
          class="bg-success text-white toast"
        >
          {{ alertMessage }}
        </div>
      </transition>
      <div v-if="$route.params.articleId" class="col-12 text-end mb-3">
        <language-select
          v-model="language"
          @change="handleChangeLanguage"
        ></language-select>
      </div>
      <div class="col-9">
        <h3 class="article-detail-title">{{ $t("label.create") }}</h3>
        <span v-show="!article.requestedAt" class="article-detail-subtitle">{{
          $t("label.draft")
        }}</span>
      </div>
      <div class="col-3">
        <button
          v-if="showSaveButton"
          v-show="isEdit"
          class="btn sc-btn sc-btn-outline mb-3"
          @click="saveArticle"
        >
          {{ $t("button.save") }}
        </button>
        <button
          v-if="$route.params.articleId"
          v-show="checkPublish()"
          :class="{ disabled: !checkPublish() }"
          class="btn sc-btn sc-btn-opaque"
          @click="publishArticle"
        >
          <span v-if="!canPublish()">{{ $t("button.request") }}</span>
          <span v-else>{{ $t("button.approve") }}</span>
        </button>
        <button
          v-if="showSetAsBannerButton"
          class="btn sc-btn sc-btn-opaque"
          @click="handleClickSetAsBannerButton"
        >
          <span>{{ $t("button.set_as_banner") }}</span>
        </button>
        <button
          v-if="showSetAsRJCButton"
          class="btn sc-btn sc-btn-opaque mt-2"
          @click="handleClickSetAsRJCButton"
        >
          <span>{{ $t("button.set_as_rjc") }}</span>
        </button>
      </div>
    </div>
    <content-tabs
      ref="contentTab"
      :active-tab="activeTab"
      :error-tabs="errorTabs"
      @change:article-tab="activeTab = $event"
    ></content-tabs>
    <div v-show="activeTab.name === 'เนื้อหาข่าว'" class="row">
      <content-body
        ref="contentBody"
        :article-id="articleId"
        :article-title="title"
        :article-body-json="contentJson"
        :can-update-content="canUpdateContent"
        @edited="updateCurrentArticle"
        @created="updateCurrentArticle($event, false)"
        @validate="setContentTabError"
      ></content-body>
      <content-meta
        ref="contentMeta"
        :article-approved-at="article.approvedAt"
        :data-settings="settings"
        :cover="cover"
        :thumbnail="thumbnail"
        :can-update-content="canUpdateContent"
        :is-thai-language="isThaiLanguage"
        @cover="updateCurrentCover"
        @changeThumbnail="handleChangeThumbnail"
        @edited="updateCurrentSettings"
        @validate="setContentTabError"
      ></content-meta>
    </div>
    <div v-show="activeTab.name === 'รายละเอียดกิจกรรม'" class="row">
      <content-event
        ref="contentEvent"
        :can-update-content="canUpdateEventContent"
        :event-settings="events"
        :is-thai-language="isThaiLanguage"
        @setEvents="updateCurrentEvents"
        @validate="setEventTabError"
      ></content-event>
    </div>
    <div v-show="activeTab.name === 'ส่งถึงใคร'" class="row">
      <content-receiver
        ref="contentReceiver"
        :can-update-content="canUpdateContent"
        :data-settings="settings"
        :is-thai-language="isThaiLanguage"
        @setProjects="updateCurrentProjects"
        @setUserRoles="updateCurrentUserRoles"
        @setHomes="updateCurrentHomes"
        @validate="setReceiverTabError"
      ></content-receiver>
    </div>
    <publish-box
      v-if="showDialog === 'publish'"
      :article.sync="article"
      :close.sync="showDialog"
      :can-publish="canPublish()"
    ></publish-box>
    <confirm-dialog
      v-show="dialogs.generalDialog.isShow"
      :data="dialogs.generalDialog.data"
      :is-h-t-m-l="dialogs.generalDialog.isHTML"
      name="generalDialog"
      @confirm="dialogs.generalDialog.isShow = false"
    ></confirm-dialog>
    <upload-banner-cover
      :is-show="dialogs.uploadBannerCover.isShow"
      :is-loading="dialogs.uploadBannerCover.isLoading"
      :can-edit="canUpdateContent"
      @cancel="handleCancelUploadBannerCover"
      @confirm="handleConfirmUploadBannerCover"
    ></upload-banner-cover>
  </div>
</template>

<script>
import axios from "axios"
import ContentTabs from "@/components/admin/view/article/create/ContentTabs"
import ContentDetailBody from "@/components/admin/view/article/create/ContentDetailBody"
import ContentMeta from "@/components/admin/view/article/create/ContentMeta"
import ContentReceiver from "@/components/admin/view/article/create/ContentReceiver"
import ContentEvent from "@/components/admin/view/article/create/ContentEvent"
import PublishBox from "@/components/admin/view/article/create/PublishBox"
import UploadBannerCover from "@/components/helper/dialog/UploadBannerCover"
import LanguageSelect from "@/lib/components/LanguageSelect"
import { localization } from "@/lib/mapper"
import * as god from "@/god"
import { getCookie, Auth } from "@/lib/cookie"

export default {
  components: {
    ContentTabs,
    "content-body": ContentDetailBody,
    "content-meta": ContentMeta,
    "content-receiver": ContentReceiver,
    "content-event": ContentEvent,
    PublishBox,
    LanguageSelect,
    UploadBannerCover,
  },
  props: {
    articleId: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      showDialog: false,
      activeTab: { name: "เนื้อหาข่าว" },
      errorTabs: [false, false, false],
      title: "",
      contentJson: {},
      events: {},
      settings: {
        selectProjects: [],
        owner: ["visitor"],
        selectHomes: null,
        category: "2",
        album: [],
        map: {},
        file: {},
      },
      cover: {
        file: {},
        key: "",
        url: "",
      },
      thumbnail: {
        file: null,
        key: null,
        url: null,
      },
      article: {},
      projects: [],
      album: [],
      isEdit: false,
      alertMessage: null,
      dialogs: {
        generalDialog: {
          isShow: false,
          isHTML: true,
          data: {
            title: "",
            detail: "",
            buttonCancel: "",
            buttonSubmit: "",
          },
        },
        uploadBannerCover: {
          isShow: false,
          isLoading: false,
        },
      },
      banner: null,
      voucher: null,
      language: localization.TH,
    }
  },
  computed: {
    showSetAsBannerButton() {
      return (
        !this.$isCallCenter &&
        this.$route.params.articleId &&
        this.isArticlePublished &&
        !this.banner
      )
    },
    showSetAsRJCButton() {
      return (
        !this.$isCallCenter &&
        this.$route.params.articleId &&
        this.isArticlePublished &&
        this.articleType === "privileges" &&
        !this.voucher
      )
    },
    articleType() {
      return this.$route.params.articleType
    },
    isArticlePublished() {
      if (this.article && this.article.approvedAt && this.article.publishAt) {
        return true
      }
      return false
    },
    isArticleDeleted() {
      if (this.article && this.article.deletedAt) {
        return true
      }
      return false
    },
    canUpdateContent() {
      return !this.$isCallCenter && !this.isArticleDeleted
    },
    canUpdateEventContent() {
      return (
        !this.$isCallCenter &&
        !this.isArticlePublished &&
        !this.isArticleDeleted
      )
    },
    showSaveButton() {
      return !this.$isCallCenter && this.checkSave() && !this.isArticleDeleted
    },
    isThaiLanguage() {
      return this.language === localization.TH
    },
  },
  watch: {
    isEdit() {
      this.$emit("edited", this.isEdit)
    },
  },
  created() {
    if (this.articleId) {
      this.getArticle(this.articleId).then(() => {
        this.setup()
      })
    }
  },
  methods: {
    async setup() {
      if (!this.isArticlePublished) {
        return
      }
      await this.setupBannerAndVoucher()
    },
    async setupBannerAndVoucher() {
      const { articleId } = this

      try {
        const banner = await god.getBanner(articleId)
        this.banner = { image_url: banner.image_url }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err)
      }

      try {
        const voucher = await god.getVoucher(articleId)
        this.voucher = { article: voucher.article }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err)
      }
    },
    handleCancelUploadBannerCover() {
      this.dialogs.uploadBannerCover.isShow = false
    },
    async handleConfirmUploadBannerCover(image) {
      const { articleId } = this

      this.dialogs.uploadBannerCover.isLoading = true
      try {
        await god.setAsBanner(articleId, image)

        this.dialogs.uploadBannerCover.isShow = false
        this.dialogs.uploadBannerCover.isLoading = false

        this.goToBannerList()
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        this.dialogs.uploadBannerCover.isShow = false
        this.dialogs.uploadBannerCover.isLoading = false
      }
    },
    handleClickSetAsBannerButton() {
      this.dialogs.uploadBannerCover.isShow = true
    },
    handleClickSetAsRJCButton() {
      const vm = this
      axios
        .post(
          `${process.env.HOST}/api/admin/ruejai_club/packages/voucher`,
          {
            article_id: this.$route.params.articleId,
          },
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
            },
          },
        )
        .then(() => {
          this.$router.push({ name: "RuejaiClubVoucherPackageListPage" })
        })
        .catch((e) => {
          vm.alertMessage = "เกิดข้อผิดพลาดในการสร้าง Voucher"
          vm.isErrorMessage = true
          setTimeout(() => {
            vm.alertMessage = null
          }, 2500)
          throw e.message
        })
    },
    resolveArticleType(type = "news") {
      const typeMap = {
        news: 1,
        activities: 2,
        privileges: 3,
      }
      return typeMap[type]
    },
    formatHomeId(homes) {
      if (Array.isArray(homes)) {
        return homes.join(",")
      }

      if (homes !== null && homes !== undefined) {
        return String(homes)
      }

      return ""
    },
    async saveArticle() {
      const validator = await this.validateArticle()

      if (validator.isValid()) {
        const vm = this
        vm.projects = []
        this.settings.selectProjects.forEach((element) => {
          vm.projects.push(element.projectId)
        })
        vm.homes = this.settings.selectHomes
        vm.album = []
        this.settings.album.forEach((element) => {
          vm.album.push(element.key)
        })
        if (this.$route.params.articleId) {
          this.updateArticle()
        } else {
          this.insertArticle()
        }
      } else {
        this.setGeneralDialog(
          "ข้อมูลไม่ครบถ้วน",
          `กรุณากรอกข้อมูลที่จำเป็นในแท็บที่แจ้งข้อมูลไม่ครบ<br>
          หากกรอกข้อมูลครบถ้วนแล้ว กดบันทึกอีกครั้งครับ`,
          "ตกลง",
        )
        this.setContentTabError(validator.body && validator.meta)
      }
    },
    setGeneralDialog(title, desc, button) {
      this.dialogs.generalDialog.data.title = title || "Title"
      this.dialogs.generalDialog.data.detail = desc || "message"
      this.dialogs.generalDialog.data.buttonCancel = button || "OK"
      this.dialogs.generalDialog.isShow = true
    },
    setConfirmDialog(title, desc, submit, cancel) {
      this.dialogs.generalDialog.data.title = title
      this.dialogs.generalDialog.data.detail = desc
      this.dialogs.generalDialog.data.buttonCancel = cancel
      this.dialogs.generalDialog.data.buttonSubmit = submit
      this.dialogs.generalDialog.isShow = true
      this.dialogs.generalDialog.isHTML = true
    },
    setContentTabError(isValid) {
      this.errorTabs[0] = !isValid
      this.$refs.contentTab.$forceUpdate()
    },
    setEventTabError(isValid) {
      this.errorTabs[1] = !isValid
      this.$refs.contentTab.$forceUpdate()
    },
    setReceiverTabError(isValid) {
      this.errorTabs[2] = !isValid
      this.$refs.contentTab.$forceUpdate()
    },
    insertArticle() {
      const vm = this

      // Backend ใช้ rent_to_own (snake_case), frontend ใช้ rentToOwn
      const roleToBackend = { rentToOwn: "rent_to_own" }
      const ownerRoles = Array.isArray(vm.settings.owner)
        ? vm.settings.owner
        : []
      const clientRole = ownerRoles.map((r) => roleToBackend[r] || r)

      // homeId ต้องเป็น string (backend: Joi.string().allow(null))
      const homeId = this.formatHomeId(vm.homes)

      // projectId ต้องเป็น array of numbers (backend validator)
      const projectId = vm.projects.length
        ? vm.projects.map((id) =>
            typeof id === "number" ? id : parseInt(id, 10),
          )
        : undefined

      const contentOps = vm.contentJson && vm.contentJson.ops
      const contentStr = contentOps != null ? JSON.stringify(contentOps) : "[]"

      const params = {
        type: this.resolveArticleType(this.articleType),
        category: vm.settings.category ? vm.settings.category : undefined,
        title: vm.title,
        coverImage: vm.cover.key || null,
        thumbnailImage: vm.thumbnail.key || null,
        content: contentStr,
        projectId,
        clientRole: clientRole.length ? clientRole : undefined,
        album: vm.album,
        locationTitle:
          (vm.settings.map && vm.settings.map.locationName) || null,
        latitude:
          vm.settings.map && vm.settings.map.lat != null
            ? Number(vm.settings.map.lat)
            : null,
        longitude:
          vm.settings.map && vm.settings.map.lng != null
            ? Number(vm.settings.map.lng)
            : null,
        fileUrl: (vm.settings.file && vm.settings.file.fileKey) || null,
        fileName: (vm.settings.file && vm.settings.file.name) || null,
        homeId: homeId || null,
        privilege: vm.articleType === "news" ? null : vm.events,
      }

      if (
        params.privilege &&
        params.privilege.codes &&
        params.privilege.codes.length > 0
      ) {
        params.privilege = {
          ...params.privilege,
          quota: params.privilege.codes.length,
        }
      }

      axios
        .post(`${process.env.HOST}/api/admin/articles`, params, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then((res) => {
          if (res.status) {
            vm.isEdit = false
            this.$emit("edited", this.isEdit)
            this.$router.push({
              name: "ArticleList",
              params: { articleType: this.articleType },
            })
          }
        })
        .catch((e) => {
          vm.alertMessage = "กรุณาตรวจสอบข้อมูลให้ครบถ้วน แล้วลองบันทึกอีกครั้ง"
          vm.isErrorMessage = true
          setTimeout(() => {
            vm.alertMessage = null
          }, 2500)
          throw e.message
        })
    },
    updateArticle() {
      const vm = this
      const roleToBackend = { rentToOwn: "rent_to_own" }
      const ownerRoles = Array.isArray(vm.settings.owner)
        ? vm.settings.owner
        : []
      const clientRole = ownerRoles.map((r) => roleToBackend[r] || r)
      const homeId = this.formatHomeId(vm.homes)
      const projectId = vm.projects.length
        ? vm.projects.map((id) =>
            typeof id === "number" ? id : parseInt(id, 10),
          )
        : undefined

      const params =
        this.language !== localization.TH
          ? {
              title: vm.title,
              coverImage: vm.cover.key,
              thumbnailImage: vm.thumbnail.key,
              content: JSON.stringify(vm.contentJson.ops),
              type: this.resolveArticleType(this.articleType),
              clientRole: clientRole.length ? clientRole : undefined,
              homeId: homeId || null,
            }
          : {
              type: this.resolveArticleType(this.articleType),
              category: vm.settings.category ? vm.settings.category : undefined,
              title: vm.title,
              coverImage: vm.cover.key,
              thumbnailImage: vm.thumbnail.key,
              content: JSON.stringify(vm.contentJson.ops),
              projectId,
              homeId: homeId || null,
              clientRole: clientRole.length ? clientRole : undefined,
              album: vm.album,
              locationTitle:
                (vm.settings.map && vm.settings.map.locationName) || null,
              latitude:
                vm.settings.map && vm.settings.map.lat != null
                  ? Number(vm.settings.map.lat)
                  : null,
              longitude:
                vm.settings.map && vm.settings.map.lng != null
                  ? Number(vm.settings.map.lng)
                  : null,
              fileUrl: (vm.settings.file && vm.settings.file.fileKey) || null,
              fileName: (vm.settings.file && vm.settings.file.name) || null,
              privilege: vm.articleType === "news" ? null : vm.events,
            }

      if (
        params.privilege &&
        params.privilege.codes &&
        params.privilege.codes.length > 0
      ) {
        params.privilege = {
          ...params.privilege,
          quota: params.privilege.codes.length,
        }
      }

      const url =
        this.language === localization.TH
          ? `${process.env.HOST}/api/admin/articles/${this.$route.params.articleId}`
          : `${process.env.HOST}/api/admin/articles/${this.$route.params.articleId}/translation`

      // if (this.isArticlePublished && (this.language === localization.TH)) {
      //   url += "/published";
      // }

      const headers =
        this.language === localization.TH
          ? { Authorization: `Bearer ${getCookie(Auth.AccessToken)}` }
          : {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
              "x-accept-language": this.language,
            }

      axios
        .put(url, params, { headers })
        .then((res) => {
          if (res.status) {
            vm.alertMessage = "บันทึกข้อมูลเรียบร้อย"
            vm.isErrorMessage = false
            setTimeout(() => {
              vm.alertMessage = null
            }, 2500)
            vm.isEdit = false
          }
        })
        .catch((e) => {
          vm.alertMessage = "กรุณาตรวจสอบข้อมูลให้ครบถ้วน แล้วลองบันทึกอีกครั้ง"
          vm.isErrorMessage = true
          setTimeout(() => {
            vm.alertMessage = null
          }, 2500)

          throw e.message
        })
    },
    publishArticle() {
      if (this.checkPublish()) {
        this.showDialog = "publish"
      }
    },
    checkSave() {
      if (
        localStorage.getItem("adminRole") === "3" &&
        this.article.requestedAt
      ) {
        return false
      }

      return true
    },
    checkPublish() {
      let valid = true

      if (["1", "2"].indexOf(localStorage.getItem("adminRole")) < 0) {
        if (this.article.requestedAt) {
          valid = false
        }
      }
      if (this.isEdit) {
        valid = false
      }
      if (this.article.approvedAt) {
        valid = false
      }
      if (this.article.content === null) {
        valid = false
      }

      return valid
    },
    getArticle(articleId) {
      const vm = this
      const headers =
        this.language === localization.TH
          ? { Authorization: `Bearer ${getCookie(Auth.AccessToken)}` }
          : {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
              "x-accept-language": this.language,
            }

      return axios
        .get(`${process.env.HOST}/api/admin/articles/${articleId}`, { headers })
        .then((res) => {
          if (res.data) {
            vm.title = res.data.title
            vm.contentJson = JSON.parse(res.data.content)
            vm.downloadImage(res.data.cover)
            vm.downloadThumbnail(res.data.thumbnail)

            vm.events = res.data.privilege

            vm.settings.selectProjects = res.data.articlesProjects
            vm.settings.selectHomes = res.data.articlesHomes
            vm.settings.owner = []
            if (res.data.ownerStatus) {
              vm.settings.owner.push("owner")
            }
            if (res.data.renterStatus) {
              vm.settings.owner.push("renter")
            }
            if (res.data.contractStatus) {
              vm.settings.owner.push("contract")
            }
            if (res.data.bookingStatus) {
              vm.settings.owner.push("booking")
            }
            if (res.data.residentStatus) {
              vm.settings.owner.push("resident")
            }
            if (res.data.visitorStatus) {
              vm.settings.owner.push("visitor")
            }
            if (res.data.rentToOwnStatus) {
              vm.settings.owner.push("rentToOwn")
            }
            vm.downloadAlbum(res.data.articlesAlbums)
            vm.settings.map = {
              lat: res.data.latitude,
              lng: res.data.longitude,
              locationName: res.data.locationTitle,
            }
            vm.settings.file = {
              fileKey: res.data.fileUrl,
              name: res.data.fileName,
            }
            vm.article = res.data
          }
        })
        .catch((e) => {
          throw e
        })
    },
    goToBannerList() {
      this.$router.push({ name: "BannerList" })
    },
    downloadImage(imageKey) {
      const vm = this
      if (imageKey) {
        axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey,
            },
          })
          .then((res) => {
            vm.cover.key = imageKey
            vm.cover.url = res.data.url
            vm.$emit("cover", vm.cover)
          })
          .catch(() => {
            // swallow image download failures to keep the editor usable
          });
      }
    },
    downloadThumbnail(imageKey) {
      const vm = this
      if (imageKey) {
        axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey,
            },
          })
          .then((res) => {
            vm.thumbnail.key = imageKey
            vm.thumbnail.url = res.data.url
          })
          .catch(() => {
            // swallow image download failures to keep the editor usable
          });
      }
    },
    downloadAlbum(album) {
      const vm = this
      if (album) {
        album.forEach((val, index) => {
          axios
            .get(`${process.env.HOST}/api/downloads/image`, {
              params: {
                imageKey: val.image,
              },
            })
            .then((res) => {
              vm.$set(vm.settings.album, index, {
                key: val.image,
                url: res.data.url,
                name: `image${index + 1}`,
              })
            })
            .catch(() => {
              // swallow image download failures to keep the rest of the album loading
            });
        });
      }
    },
    updateCurrentArticle(editedContent, edited = true) {
      this.title = editedContent.title
      this.contentJson = editedContent.contentJson
      this.isEdit = edited
      this.$emit("updated", editedContent)
    },
    updateCurrentSettings(editedSettings) {
      this.settings = editedSettings
      this.isEdit = true
    },
    updateCurrentCover(editedCover) {
      this.cover = editedCover
      this.isEdit = true
      this.$emit("cover", editedCover)
    },
    updateCurrentProjects(editedProjects) {
      this.settings.selectProjects = editedProjects
      this.isEdit = true
    },
    updateCurrentUserRoles(editedUserRoles) {
      this.settings.owner = editedUserRoles
      this.isEdit = true
    },
    updateCurrentHomes(editedHomes) {
      this.settings.selectHomes = editedHomes
      this.isEdit = true
    },
    updateCurrentEvents(editedEvents) {
      this.events = editedEvents
      this.isEdit = true
    },
    async validateArticle() {
      const vm = this
      const result = {
        body: false,
        meta: false,
        receiver: false,
        event: false,
        isValid() {
          if (vm.articleType === "news") {
            return this.body && this.meta && this.receiver
          }

          return this.body && this.meta && this.receiver && this.event
        },
      }

      result.body = await this.$refs.contentBody.validate()
      result.meta = await this.$refs.contentMeta.validate()
      result.receiver = await this.$refs.contentReceiver.validate()
      result.event = await this.$refs.contentEvent.validate()

      return result
    },
    async handleChangeThumbnail(file) {
      this.isEdit = true
      const { imageKey } = await this.uploadImage(file)

      const url = URL.createObjectURL(file)
      this.thumbnail.file = file
      this.thumbnail.key = imageKey
      this.thumbnail.url = url
    },
    async uploadImage(img) {
      const headers = { "content-type": img.type }
      const { data } = await this.getUploadMeta(img)
      await axios.put(data.url, img, { headers })

      return data
    },
    getUploadMeta(img) {
      const params = {
        imageType: img.type,
        imageName: `articlecover${Date.now()}`,
        featureName: "article",
      }

      return axios.get(`${process.env.HOST}/api/uploads/image`, { params })
    },
    handleChangeLanguage() {
      this.getArticle(this.articleId).then(() => {
        this.setup()
      })
    },
    canPublish() {
      const adminProjects = localStorage.getItem("adminProjects").split(",")
      const articlesProjects = this.article.articlesProjects
        ? this.article.articlesProjects
        : []
      const canAccessArticle = adminProjects.some((projectId) =>
        articlesProjects
          .map((articleProject) => articleProject.projectId)
          .includes(projectId),
      )

      const canPublish =
        localStorage.getItem("adminRole") === "1" ||
        (localStorage.getItem("adminRole") === "2" && canAccessArticle)

      return canPublish
    },
  },
}
</script>

<style scoped>
.toast {
  font-size: 14px;
  position: absolute;
  border-radius: 10em;
  padding: 5px 40px;
  box-shadow: 1px 1px 15px -5px black;
  left: calc(50% - 111px);
}
.bg-danger {
  left: calc(50% - 222px);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.content-left {
  padding: 25px;
}
</style>
